import Vue from "vue";

export const state = Vue.observable({
  results: [],
  total: 0,
  pagination: {},
  filters: {}
});

export const mutations = {
  setResults: (results) => {
    results.forEach((element, index) => {
      element.index = index
    });
    state.results = results
  },
  setTotalResults: (total) => {
    state.total = total
  },
  setPagination: (pagination) => {
    state.pagination = pagination
  },
  setFilters: (filters) => {
    state.filters = filters
  }
}